module.exports = __webpack_public_path__ + "static/media/symptoms-vitals-and-lifestyle-tracking-02@3x.0842f61c.png";